(function () {

  'use strict';

  angular
    .module('specsguardApp')
    .directive('sgElementCounter', sgElementCounter);

  function sgElementCounter () {

    return {
      template: '{{elementcount}}',
      restrict: 'EA',
      scope: {
        modules: '=',
        projectLevel: '=',
        knowledgeLevel: '='
      },
      link: function (scope, element, attrs) {

        const modules = scope.modules;
        const constructionId = attrs.constructionId;
        const projectLevel = scope.projectLevel._id;
        const knowledgeLevel = scope.knowledgeLevel._id;

        scope.elementcount = modules ?
          modules.reduce(function (memo, module) {
            if (module.active) {
              return memo + module.submodules.reduce(function (memo2, submodule) {
                if (submodule.active) {
                  return memo2 + submodule.elements.reduce(function (memo3, elem) {
                    if (elem.active &&
                      elem.constructionId.toString() === constructionId.toString() &&
                      elem.projectLevel.toString() === projectLevel.toString() &&
                      elem.knowledgeLevel.toString() === knowledgeLevel.toString()) {
                      return memo3 + 1;
                    }
                    return memo3;
                  }, 0);
                }
                return memo2;
              }, 0);
            }
            return memo;
          }, 0)
          : 0;
      }
    };
  }

})();
